import { render, staticRenderFns } from "./addRecord.vue?vue&type=template&id=a0f6a59a&scoped=true&"
import script from "./addRecord.vue?vue&type=script&lang=js&"
export * from "./addRecord.vue?vue&type=script&lang=js&"
import style0 from "./addRecord.vue?vue&type=style&index=0&id=a0f6a59a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f6a59a",
  null
  
)

export default component.exports